import styled, { useTheme } from "styled-components";
import { Flex, Box, useScreenResolution, Button, Icon } from "dash-ui";
import LogoImg from "assets/images/png/logo.png";
import ProfileDropdown from "flow-components/Header/components/ProfileDropdown/ProfileDropdown";
import { useLogout } from "common/hooks/useLogout/useLogout";

const HeaderStyle = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors.n30};
  background-color: ${({ theme }) => theme.colors.white};
  position: fixed;
  z-index: 5;
`;

function Logout() {
  const theme = useTheme();
  const [logout] = useLogout();
  return (
    <div className="flex flex-row items-center gap-2 mr-4">
      <Icon name="logout" color={theme.colors.n90} />
      <a href="#" onClick={logout} className="text-slate-600">
        Logout
      </a>
    </div>
  );
}

function Header({
  withProfileDropdown = true,
  withLogoutButton = false,
}: {
  withProfileDropdown?: boolean;
  withLogoutButton?: boolean;
}) {
  const {
    devices: { isMobile },
  } = useScreenResolution();

  return (
    <Box h={50}>
      <HeaderStyle
        flex={1}
        w="100%"
        h={50}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center">
        <Flex>
          <Box ml={isMobile ? 4 : 19}>
            <a href={`${window.location.origin}`}>
              <img src={LogoImg} alt="Dash Logo" />
            </a>
          </Box>
        </Flex>
        {withProfileDropdown && <ProfileDropdown />}
        {withLogoutButton && !withProfileDropdown && <Logout />}
      </HeaderStyle>
    </Box>
  );
}

export default Header;
